import React, { createContext, useEffect, useState } from 'react';
import axios from 'axios';
import { showMain, hideMain } from '../helpers/helperFunctions.js';
import { useLanguage, LanguageProvider } from "../i18n/LanguageContext.jsx";
import i18n from "../i18n/i18n";

export const AppContext = createContext(null);

export const ContextWrapper = ({ children }) => {
	const [siteMap, setSiteMap] = useState(null);
	const [error, setError] = useState(null);
	const [loaderDuration, setLoaderDuration] = useState(5);
	const { language } = useLanguage()

	axios.interceptors.response.use(function (response) {
		// Any status code that lie within the range of 2xx cause this function to trigger
		// Do something with response data
		return response;
	}, function (error) {
		// Any status codes that falls outside the range of 2xx cause this function to trigger
		// Do something with response error
		setError(error)
		//console.error('Errore durante il fetchla richiesta:', error);
		return Promise.reject(error)
	});

	axios.interceptors.request.use(function (config) {
		// Do something before request is sent

		let urlSearch = new URLSearchParams(window.location.search);
		if (urlSearch.get("t") && urlSearch.get("t") == "nocache") {
			config.params = { ...config.params, timestamp: Date.now() }
			//console.log(`Estendo config: ${JSON.stringify(config)} per ${urlSearch.get("t") }`)
		}
		return config;
	}, function (error) {
		// Do something with request error
		return Promise.reject(error);
	});

	useEffect(() => {
		const onScroll = () => {
			const pageHero = document.querySelector(".page-hero");
			const header = document.querySelector("header");
			if (window.scrollY > 1) {
				header.classList.add("header-small")
			} else {
				header.classList.remove("header-small")
			}


			if (!pageHero) return;

			if (window.scrollY > 0 && (window.scrollY > (pageHero.offsetHeight - 60))) {
				header.classList.add("header-collapse")
			} else {
				header.classList.remove("header-collapse")
			}
		}
		// clean up code
		window.removeEventListener('scroll', onScroll);
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	useEffect(() => {
		const fetchData = async () => {
			try {
				//incrementApiCalls();
				const res = await axios.get(`/${language}/sitemap/json`);
				const response = res.data;
				return response;
			} catch (error) {
				//console.error('Errore durante il fetchla siteMap:', error);
			} finally {
				//decrementApiCalls();
			}
		};

		const addBranch = (out, branch) => {
			for (let i = 0; i < branch.length; i++) {
				let el = branch[i]
				//let key = el.key || "home"
				let key = el.viewId || "home"
				out[key] = el
				if (el.childItems.length) {
					addBranch(out, el.childItems)
				}
			}
		}

		const dataToSiteMap = async (data) => {
			let out = {};
			for (let i = 0; i < data.length; i++) {
				let el = data[i]
				//let key = el.key || "home"
				let key = el.viewId || "home"
				out[key] = el
				if (el.childItems.length) {
					addBranch(out, el.childItems)
				}
			}
			return out;
		}

		fetchData().then(data => {
			dataToSiteMap(data[0].items).then(res => {
				//console.log(res)
				setSiteMap(res)
			})
		})
	}, [language]);



	return (
		<AppContext.Provider
			value={{
				siteMap,
				loaderDuration,
				setLoaderDuration,
				error,
				setError
			}}
		>
			{children}
		</AppContext.Provider>
	);
};
